import type { GridProps } from "@dealer-center/core-components";
import { Grid } from "@dealer-center/core-components";

export const GridContainer = (props: GridProps) => (
  <Grid container spacing={2} sx={{ padding: "8px 4px" }} {...props} />
);
